import { useState, useEffect} from 'react';
import { 
  Grid,
  Paper, 
  Typography,
  TextField,
  Grow,
} from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import Icon from '@mui/material/Icon'; 
import { LoadingButton } from '@mui/lab';
import { Done, Save } from '@mui/icons-material';
import { useNotepad } from '../notepad/api/getNotepad';
import { useUpdateNotepad } from './api/updateNotepad';


const NotepadWidget = () => {
  const updateNotepad = useUpdateNotepad({});
  const { data: notepad } = useNotepad({notepadId: 1});
  const [noteField, setNoteField] = useState('');
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const needToSaveNote = noteField !== notepad?.note;

  const saveNote = async () => {
    if (needToSaveNote){
      setLoading(true);
      await updateNotepad.mutateAsync({
        data: {
          note: noteField,
        },
        notepadId: 1
      });
      setLoading(false);
    }
  };

  function handleExpand(){ 
    setExpanded(!expanded);
  }

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  useEffect(() => {
    setNoteField(notepad?.note || '');
  }, [notepad?.note])
  
  return (
    <>
      <Grid container item component={Paper} justifyContent={'center'} 
        bgcolor={(isHovering && !expanded) ? `action.hover` : 'none'}
        >
        <Grid
          container
          item
          alignItems='center'
          justifyContent='center'
          spacing={1}
          xs={12}
          onClick={handleExpand}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}>
            <Grid item>
              <EventNoteIcon style={{ verticalAlign: 'middle'}} />
            </Grid>
            <Grid item>
              <Typography variant='h6'>Notepad</Typography>
            </Grid>
            <Grid item>
              <Icon>
                {expanded ? <ExpandMoreIcon/> : <ExpandLessIcon/>}
              </Icon>
            </Grid>
        </Grid>
        <Grid item xs={12}>
      <Collapse in={expanded}>
        <Grid item xs={12} sx={{mr: '1rem', ml:'1rem'}} >
          <TextField
          value={noteField}
          onChange={(e) => setNoteField(e.target.value)}
          fullWidth
          multiline
          minRows={4}
          maxRows={12}
          />
        </Grid>
        
        <Grid
          container
          item
          justifyContent={'flex-end'}
          spacing={1}
          alignItems={'center'}
          sx={{ pr:'1rem', pb:'0.5rem', pt:'0.5rem'}}
        >
          <Grid item>
            <LoadingButton
            type={'submit'}
            onClick={saveNote}
            disabled={!needToSaveNote}
            variant={'contained'}
            loading={loading}
            loadingPosition={'start'}
            startIcon={
              needToSaveNote ? (
                <Save />
              ) : (
                <Grow in={!needToSaveNote}>
                  <Done />
                </Grow>
              )
            }
          >
            {needToSaveNote ? 'Save' : 'Saved'}
            </LoadingButton>
          </Grid>
        </Grid>
      </Collapse>
      </Grid>
    </Grid>
    </>
  );
};

export default NotepadWidget;
